import { compose, getContext } from 'recompose';
import { prop } from 'ramda';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Grid from './grid';

import { withSorting } from '../../../../utils/enchancers';
import { getOppositeValue } from '../../../../utils/helpers/commonHelpers';
import { projectActions } from '../../../../state/project';
import { filterAndTransformCondition, filterParamKey } from '../../../../utils/helpers/uiComponentHelpers/filters';

const mapDispatchToProps = ({
  sortProjectTasks: projectActions.sortProjectTasksRequest,
});

const changeParamKey = (e) => {
  const [key, value] = e;
  return ({ field: key, value });
};

const enhance = compose(
  connect(null, mapDispatchToProps),
  withTranslation(['tasks']),
  getContext({
    projectId: PropTypes.number,
    onSetUrlParam: PropTypes.func,
    getUrlParam: PropTypes.func,
    whereForTasks: PropTypes.instanceOf(Array),
    filters: PropTypes.instanceOf(Object),
  }),
  withSorting({
    selector: props => props.getUrlParams(),
    values: ({
      order: ({ getUrlParam, name }) => getUrlParam(['grid', name, 'order'], 'asc'),
      sort: ({ getUrlParam, name }) => getUrlParam(['grid', name, 'sort'], 'id'),
    }),
    onSortBy: ({
      order,
      name,
      sortProjectTasks,
      projectId,
      isSprint,
      onSetUrlParam,
      id,
      filters,
    }) => (dataSorting) => {
      const sortBy = prop('sortBy', dataSorting);
      const newOrdering = getOppositeValue('asc', 'desc', order);
      const where = filterAndTransformCondition(filterParamKey, changeParamKey, filters);
      onSetUrlParam({ grid: ({ [name]: ({ sort: sortBy, order: newOrdering }) }) });
      sortProjectTasks({
        projectId,
        where: ([{ field: 'sprint_id', value: isSprint ? id : 'null' }, ...where]),
        sortBy,
        order: newOrdering,
      }, { sprintId: id, isSprint });
    },
  }),
);
export default enhance(Grid);
